import { cookiesName } from '../../../constants';
import Cookie from '../../../helpers/Cookies';

export const dyApiConfig = {
  // url: 'https://dy-api.com/v2/serve/user/choose',
  url: 'https://direct.dy-api.com/v2/serve/user/choose',
  key: 'fe27da30819f652c57b55e5f05abe549ccf4e519e974a192824ff480e440e171',
};

const DEFAULT_PAGE_TYPE = 'PRODUCT';
const PAGE_SELECTOR_GROUPS = ['global', 'page'];

function isMobileDevice() {
  return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
}

function waitForDY(timeout = 5000, interval = 100) {
  return new Promise((resolve) => {
    const startTime = Date.now();

    const check = () => {
      if (typeof window.DY !== 'undefined') {
        resolve(window.DY);
      } else if (Date.now() - startTime > timeout) {
        resolve(null);
      } else {
        setTimeout(check, interval);
      }
    };

    check();
  });
}

export function getRecommendationContext() {
  return window.DY && window.DY.recommendationContext
    ? window.DY.recommendationContext
    : {};
}

export function getDefaultPageContext(defaultType = DEFAULT_PAGE_TYPE) {
  const recommendationContext = getRecommendationContext();

  return {
    type: recommendationContext.type || defaultType,
  };
}

export function getUserData() {
  const cookieDyid = Cookie.get(cookiesName.external.dy.dyid);
  const cookieJsession = Cookie.get(cookiesName.external.dy.dyjsession);

  if (cookieDyid && cookieJsession) {
    return Promise.resolve({
      dyid: cookieDyid,
      jsession: cookieJsession,
    });
  }

  return waitForDY().then((DY) => ({
    dyid: cookieDyid || (DY && DY.dyid) || null,
    jsession: cookieJsession || (DY && DY.jsession) || null,
  }));
}

export function buildChooseBody({
  userData = {},
  pageContext = {},
  selectorNames = [],
  selectorGroups = [],
  listedItems = [],
  args = false,
}) {
  const recommendationContext = getRecommendationContext();
  const pageAttributes = {
    globalControlGroup: 'Dynamic Yield Experiences',
  };
  const context = {
    device: {
      type: isMobileDevice() ? 'smartphone' : 'DESKTOP',
      userAgent: window.navigator.userAgent,
    },
    page: Object.assign(
      {
        type: 'OTHER',
        locale: 'en_US',
        location: document.location.href,
        data: recommendationContext.data || [],
      },
      pageContext || {}
    ),
  };

  if (window.ip) {
    context.device.ip = window.ip;
  }

  if (window.cartData) {
    pageAttributes.cartItemsCount = `${window.cartData.item_count}`;

    if (Array.isArray(window.cartData.items)) {
      context.cart = window.cartData.items.map((item) => ({
        productId: item.id,
        quantity: item.quantity,
        itemPrice: parseFloat(item.final_line_price / 100),
      }));
    }
  }

  if (document.referrer) {
    context.page.referrer = document.referrer;
  }

  if (Array.isArray(listedItems) && listedItems.length) {
    context.listedItems = listedItems.slice(0, 300);
  }

  if (Object.keys(pageAttributes).length) {
    context.pageAttributes = pageAttributes;
  }

  const body = {
    selector: {
      names: selectorNames,
      groups: selectorGroups,
    },
    context,
    options: {
      isImplicitPageview: false,
      returnAnalyticsMetadata: false,
      isImplicitImpressionMode: true,
    },
    session: {
      dy: userData.jsession || (window.DY && window.DY.jsession) || null,
    },
  };

  if (args) {
    body.selector = Object.assign({}, body.selector, { args });
  }

  if (userData && userData.dyid) {
    body.user = {
      dyid: userData.dyid,
      dyid_server: userData.dyid,
    };
  }

  return body;
}

export async function dyChoose(options = {}) {
  const {
    pageContext = {},
    selectorNames = [],
    selectorGroups = [],
    listedItems = [],
    args = false,
  } = options;

  const userData = await getUserData();
  const body = buildChooseBody({
    userData,
    pageContext,
    selectorNames,
    selectorGroups,
    listedItems,
    args,
  });

  const sendEvent = ({ data }) => {
    window.dataLayer = window.dataLayer || [];

    // console.log('DY CHOOSE sendEvent', data);
    const choices = data.choices || [];
    // const experimentIds = choices.map((choice) => choice.experimentId).join(', ');
    choices.forEach((choice) => {
      window.dataLayer.push({
        event: 'dy_impression',
        experienceName: choice.id,
        campaignName: choice.name,
      });

      const variations = choice.variations || [];
      if (variations.length > 0) {
        variations.forEach((variation) => {
          window.dataLayer.push({
            event: 'dy_variation_impression',
            experienceName: choice.id,
            campaignName: choice.name,
            variationName: variation.id,
          });
        });
      }
    });
  };
  try {
    const response = await fetch(dyApiConfig.url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'DY-API-Key': dyApiConfig.key,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();

    sendEvent({ data });

    return data;
  } catch (e) {
    console.error(`ERROR IN CHOOSE: ${e.message}`);
    return e;
  }

  // return getUserData()
  //   .then((userData) => {
  //     const body = buildChooseBody({
  //       userData,
  //       pageContext,
  //       selectorNames,
  //       selectorGroups,
  //       listedItems,
  //       args,
  //     });

  //     return fetch(dyApiConfig.url, {
  //       method: 'POST',
  //       headers: {
  //         accept: 'application/json',
  //         'content-type': 'application/json',
  //         'DY-API-Key': dyApiConfig.key,
  //       },
  //       body: JSON.stringify(body),
  //     }).then((response) => response.json());
  //   })
  //   .catch((e) => {
  //     console.error(`ERROR IN CHOOSE: ${e.message}`);
  //     return e;
  //   });
}

export function loadDyPageData() {
  return dyChoose({
    pageContext: getDefaultPageContext(),
    selectorGroups: PAGE_SELECTOR_GROUPS,
  }).then((dyData) => {
    window.dyDataLayer = dyData;
    return dyData;
  });
}
